import {forwardRef, ForwardedRef, ReactNode} from "react";
import FaiTypographyRoot from "./FaiTypographyRoot";

// MUI context
import {useFaiController} from "../../context";

interface FaiTypographyProps {
    color?: "inherit" | "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark" | "text" | "white";
    fontWeight?: "light" | "regular" | "medium" | "bold";
    textTransform?: "none" | "capitalize" | "uppercase" | "lowercase";
    verticalAlign?: "unset" | "baseline" | "sub" | "super" | "text-top" | "text-bottom" | "middle" | "top" | "bottom";
    textGradient?: boolean;
    children: ReactNode;
    opacity?: number;

    [key: string]: any;
}

const FaiTypography = forwardRef((props: FaiTypographyProps, ref: ForwardedRef<any>) => {
    const {
        color = "dark",
        fontWeight = "regular",
        textTransform = "none",
        verticalAlign = "unset",
        textGradient = false,
        opacity = 1,
        children,
        ...rest
    } = props;

    const [controller] = useFaiController();
    const {darkMode} = controller;

    return (
        <FaiTypographyRoot
            {...rest}
            ref={ref}
            ownerState={{
                color,
                textTransform,
                verticalAlign,
                fontWeight,
                opacity,
                textGradient,
                darkMode,
            }}
        >
            {children}
        </FaiTypographyRoot>
    );
});

export default FaiTypography;
